exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".form-group .control-label {\n  text-align: left;\n  padding-left: 0; }\n\n.form-group button {\n  margin-right: 15px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/app-profile/app-inquiry/app-inquiry.component.scss
// module id = 489
// module chunks = 0